// extracted by mini-css-extract-plugin
var _1 = "#101B21";
var _2 = "#709FFF";
var _3 = "#EDEEF0";
var _4 = "#51545A";
var _5 = "#E1E3E6";
var _6 = "#FFECE9";
var _7 = "https://g0.evitecdn.com/";
var _8 = "#101B21";
var _9 = "#FF9548";
var _a = "#C75300";
var _b = "#B9BCBF";
var _c = "#92959B";
var _d = "#E2ECFF";
var _e = "#66DB86";
var _f = "#20883C";
var _10 = "#28A842";
var _11 = "min-width: 80rem";
var _12 = "#3B5998";
var _13 = "#FF6348";
var _14 = "#FFECE9";
var _15 = "#FFECE9";
var _16 = "#D62000";
var _17 = "#709FFF";
var _18 = "#E2ECFF";
var _19 = "#E2ECFF";
var _1a = "#2424E5";
var _1b = "#FF9548";
var _1c = "#E092FF";
var _1d = "#B9BCBF";
var _1e = "#66DB86";
var _1f = "#E3FBE4";
var _20 = "#E3FBE4";
var _21 = "#20883C";
var _22 = "#FF9548";
var _23 = "#FFF5ED";
var _24 = "#FFF5ED";
var _25 = "#C75300";
var _26 = "#66DB86";
var _27 = "#F5F5F7";
var _28 = "#B9BCBF";
var _29 = "#B9BCBF";
var _2a = "#FFFFFF";
var _2b = "#FFFFFF";
var _2c = "#b31412";
var _2d = "calc(80rem - 0.1rem)";
var _2e = "min-width: 48rem";
var _2f = "calc(61.876rem - 0.1rem)";
var _30 = "min-width: 61.875rem";
var _31 = "#EBEAFD";
var _32 = "#F5F3F2";
var _33 = "#5352EB";
var _34 = "#5352EB";
var _35 = "#5352EB";
var _36 = "calc(48rem - 0.1rem)";
var _37 = "min-width: 31.25rem";
var _38 = "rgba(106, 110, 113, 0.2)";
var _39 = "#FF6348";
var _3a = "#D62000";
var _3b = "#E3FBE4";
var _3c = "rgba(227, 251, 228, 0.5)";
var _3d = "#6A6E71";
var _3e = "#92959B";
var _3f = "#6A6E71";
var _40 = "#FFFFFF";
var _41 = "#C10097";
var _42 = "#E092FF";
var _43 = "#C10097";
var _44 = "#FF9548";
var _45 = "#E092FF";
var _46 = "#66DB86";
var _47 = "#2E3136";
var _48 = "#E1E3E6";
var _49 = "calc(31.25rem - 0.1rem)";
var _4a = "min-width: 23.375rem";
var _4b = "clamp(2.5rem, 11vw, 5rem)";
var _4c = "clamp(1.5rem, 5vw, 3rem)";
var _4d = "clamp(1rem, 3vw, 1.5rem)";
var _4e = "6.5rem";
var _4f = "5rem";
var _50 = "#5352EB";
var _51 = "#2424E5";
var _52 = "#CA6E2E";
var _53 = "#E2ECFF";
var _54 = "#101B21";
var _55 = "#1DA1F2";
var _56 = "#FFF5ED";
var _57 = "#F4E2D5";
var _58 = "#FFFFFF";
export { _1 as "appleColor", _2 as "aquamarine", _3 as "ash", _4 as "asphalt", _5 as "borderColor", _6 as "bubbleGum", _7 as "cdnPath", _8 as "charcoal", _9 as "citrine", _a as "citrineWebText", _b as "cloud", _c as "coin", _d as "cottonCandy", _e as "emerald", _f as "emeraldWebText", _10 as "eviteGreen", _11 as "extraLargeAndUpQuery", _12 as "facebookColor", _13 as "feedbackError", _14 as "feedbackErrorBg", _15 as "feedbackErrorSubtle", _16 as "feedbackErrorText", _17 as "feedbackInformation", _18 as "feedbackInformationBg", _19 as "feedbackInformationSuble", _1a as "feedbackInformationText", _1b as "feedbackMaybe", _1c as "feedbackNo", _1d as "feedbackNoReply", _1e as "feedbackSuccess", _1f as "feedbackSuccessBg", _20 as "feedbackSuccessSubtle", _21 as "feedbackSuccessText", _22 as "feedbackWarning", _23 as "feedbackWarningBg", _24 as "feedbackWarningSubtle", _25 as "feedbackWarningText", _26 as "feedbackYes", _27 as "fog", _28 as "formBorder", _29 as "formBorderDisabled", _2a as "formInputBg", _2b as "ghost", _2c as "googleColor", _2d as "largeAndUp", _2e as "largeAndUpQuery", _2f as "largishAndUp", _30 as "largishAndUpQuery", _31 as "lavender", _32 as "linen", _33 as "link", _34 as "linkColor", _35 as "linkHoverColor", _36 as "mediumAndUp", _37 as "mediumAndUpQuery", _38 as "menuHover", _39 as "mexicanOpal", _3a as "mexicanOpalWebText", _3b as "mintChip", _3c as "mintChipLight", _3d as "pebble", _3e as "placeholder", _3f as "popoverColor", _40 as "popoverTextColor", _41 as "premiumColor", _42 as "rose", _43 as "roseWebText", _44 as "rsvpMaybe", _45 as "rsvpNo", _46 as "rsvpYes", _47 as "shadow", _48 as "silver", _49 as "smallAndUp", _4a as "smallAndUpQuery", _4b as "spacingLg", _4c as "spacingMd", _4d as "spacingSm", _4e as "susHeaderDesktopScrollSpacing", _4f as "susHeaderMwScrollSpacing", _50 as "tanzanite", _51 as "tanzaniteWebText", _52 as "tigersEye", _53 as "tooltipColor", _54 as "tooltipTextColor", _55 as "twitterColor", _56 as "vanilla", _57 as "waffle", _58 as "white" }
